import { Box, Grid, Slide, Stack, Typography } from '@mui/material'
import BuyButton from '../BuyButton/BuyButton'
import { ProductName } from '../ProductName/ProductName'
import ShareButton from '../ShareButton/ShareButton'
import TryOnButton from '../TryOnButton/TryOnButton'
import VariantsButton from '../VariantsButton/VariantsButton'
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react'
import PanelControlButton from '../PanelControlButton/PanelControlButton'
import { CustomYellowButtonNoShadow } from '../MuiStyledItems/CustomButtons'
import { TransitionProps } from '@mui/material/transitions'
import { formatMoney } from '../../assets/scripts/numberFormat'

//Dynamic
import dynamic from 'next/dynamic'
const MobilePriceBox = dynamic(() => import('../PriceBox/MobilePriceBox'), { ssr: false })

// Config
import { CustomModelViewerUIElementsProps } from './CustomModelViewerUIElements.config'

// Styles
import styles from './CustomModelViewerUIElements.module.scss'
import { mergeClasses } from '../../assets/scripts/cssHelper'
import { hideOnDesktop, hideOnMobile } from '../../assets/styles/windowQuery'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});



const CustomModelViewerUIElements = (props: CustomModelViewerUIElementsProps) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = React.useState(true);
  const [openMobile, setOpenMobile] = React.useState(false);

  const handleBuyNowClick = (url: string) => {
    window.open(url, '_blank');
  }

  const handleClose = () => {
    setOpenMobile(false);
  };

  return (
    <>
      {(matches && openMobile) ?
        <MobilePriceBox
          openMobile={openMobile}
          price={props.selectedVariantModel.price}
          link={props.selectedVariantModel.product_links[props.selectedVariantModel.product_links.length - 1].url}
          description={props.selectedVariantModel.description}
          handleClose={handleClose}
        />
        : <></>}
      <Box className={styles.uiContainer}>
        <Box pt={2}>
          <Grid container justifyContent="space-between">

            {props.single ? null :
              <Grid item container justifyContent={"center"} sx={{ position: "absolute" }}>
                <ProductName brandName={props.selectedVariantModel.brand_detail[0].brand_name} baseModelName={props.selectedVariantModel.base_model_detail[0].model_name} variantModelName={props.selectedVariantModel.variant_model_name} />
              </Grid>
            }

            <Grid item container justifyContent={"flex-end"} sx={{ position: "absolute" }}>
              <Stack sx={hideOnMobile}>
                <Box className={mergeClasses([styles.panelContainer, styles.infoCard])} p={3} mr={1} display={open ? "flex" : "none"}>
                  <Grid container direction={"column"} justifyContent={"space-between"}>
                    <Grid item container className={styles.descriptionContainer} mb={2}>
                      <Typography align='left' variant='customDescription'>
                        {props.selectedVariantModel.description}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Grid item pb={0.5}>
                        <Typography variant='customBody'>RETAIL PRICE: {props.selectedVariantModel.price === 0 ? "N/A" : `$ ${formatMoney(props.selectedVariantModel.price)}`}</Typography>
                      </Grid>
                      <Grid item pb={2}>
                        <Typography align='justify' variant='customBodyXsCondensed'>please verify vendor’s website for product details before purchasing</Typography>
                      </Grid>
                      <Grid item display={'flex'} textAlign='center'>
                        <CustomYellowButtonNoShadow href={props.selectedVariantModel.product_links[props.selectedVariantModel.product_links.length - 1].url} target='_blank'>Buy It</CustomYellowButtonNoShadow>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Stack>
              <Stack sx={{ ...{ zIndex: 11 }, ...hideOnDesktop }} spacing={2} pr={{ xs: 1.5, sm: 2, md: 3, lg: 4 }}>
                <ShareButton />
                <VariantsButton />
                <BuyButton buy_link={props.selectedVariantModel.product_links[props.selectedVariantModel.product_links.length - 1].url} />
                <PanelControlButton open={openMobile} setOpen={setOpenMobile} />
              </Stack>
              <Stack sx={hideOnMobile} className={mergeClasses([styles.panelContainer, styles.stackHeight])} alignItems={"center"} spacing={2} mr={{ xs: 1.5, sm: 2, md: 3, lg: 4 }} borderRadius={1}>
                <Box className={styles.controlButtons} pt={2} pb={1} borderBottom={"1px solid black"}>
                  <PanelControlButton open={open} setOpen={setOpen} />
                </Box>
                <Stack px={2} spacing={2} pb={2}>
                  <ShareButton />
                  <VariantsButton />
                  <BuyButton buy_link={props.selectedVariantModel.product_links[props.selectedVariantModel.product_links.length - 1].url} />
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Box>
        <Box>
          <Grid container alignItems={"flex-end"} justifyContent="space-between">
            <Grid item xs={2}></Grid>
            <Grid item container justifyContent={"center"} xs={6} py={matches ? 2.5 : 3}>
              <TryOnButton />
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
        </Box>
      </Box>

    </>
  )
}

export default CustomModelViewerUIElements